import { Modal, Input, Form, DatePicker } from "antd";
import { useEffect, useRef, useState } from "react";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
import { formStyle, layout } from "../styles";
import { useConfirmarReserva } from "../hooks/useConfirmarReserva";
import { useWarning } from "../../../uteis/mensagens/useWarning";
import { Dayjs } from "dayjs";

interface ModalConfirmarProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  reservaId: null | number;
}

export default function ModalConfirmar({
  isModalOpen,
  handleFechar,
  reservaId,
}: ModalConfirmarProps) {
  const [observacao, setObservacao] = useState("");
  const [dataAutorizacao, setDataAutorizacao] = useState<string | null>(null);
  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  const { showWarning, contextHolder: warningContextHolder } = useWarning();

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  const [dataConfirmacao, setDataConfirmacao] = useState("");

  const confirmacaoOnChange = (changedValues: Partial<any>, allValues: any) => {
    setDataConfirmacao(allValues);
  };

  const { atualizar, warning, errorMessage, successMessage, isLoading } =
    useConfirmarReserva(reservaId, dataConfirmacao);

  const warningRef = useRef<string | null>(null);
  const errorRef = useRef<string | null>(null);

  useEffect(() => {
    if (warning) {
      warningRef.current = warning;
    }
    if (errorMessage) {
      errorRef.current = errorMessage;
    }
  }, [warning, errorMessage]);
  // Funçao navigate que é utilizada para o reload da página
  const navigate = useNavigate();
  useEffect(() => {
    if (successMessage && !successDisplayed) {
      showSuccess(successMessage);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 4000);
    }
    if (warningRef.current && !warningDisplayed) {
      showWarning(warningRef.current);
      setWarningDisplayed(true);

      setTimeout(() => {
        warningRef.current = null;
        setWarningDisplayed(false);
      }, 2000);
    }
    if (errorRef.current && !errorDisplayed) {
      showError(errorRef.current);
      setErrorDisplayed(true);

      setTimeout(() => {
        errorRef.current = null;
        setErrorDisplayed(false);
      }, 2000);
    }
  }, [
    warning,
    errorMessage,
    showError,
    errorDisplayed,
    warningDisplayed,
    showWarning,
    successMessage,
    showSuccess,
    successDisplayed,
    navigate,
  ]);
  const handleDateChange = (
    date: Dayjs | null,
    dateString: string | string[]
  ) => {
    setDataAutorizacao(typeof dateString === "string" ? dateString : null);
  };
  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Confirmar Data Reserva"
      cancelText="Cancelar"
      okText="Incluir"
      confirmLoading={isLoading}
      okButtonProps={{
        disabled: !observacao.trim(),
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        },
      }}
      onOk={() => {
        atualizar();
      }}
    >
      <>
        <>{errorContextHolder}</>
        <>{successContextHolder}</>
        <>{warningContextHolder}</>
        <Form
          {...layout}
          onValuesChange={(changedValues, allValues) =>
            confirmacaoOnChange(changedValues, allValues)
          }
          name="reserva-confirmacao"
          style={formStyle}
          // validateMessages={validarFormulario}
        >
          <Form.Item
            name={["dataConfirmacao"]}
            label="Data Confirmação "
            className="formItems"
          >
            <DatePicker format="DD/MM/YYYY" onChange={handleDateChange} />
          </Form.Item>

          {dataAutorizacao && (
            <Form.Item name={["observacao"]} label="Observação">
              <Input.TextArea
                placeholder="Informe Observação"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                rows={4}
                style={{ marginBottom: 16 }}
              />
            </Form.Item>
          )}
        </Form>
      </>
    </Modal>
  );
}
